import type { SelectOptionList } from '@lbcamden/lib-react';

export type RecommendationDepartment = (typeof actionTypeOptions)[number]['groupId'];

export const actionTypeOptions = [
  {
    groupId: 'bsm',
    label: 'Building Safety Managers',
    options: [
      {
        id: 'bsmSprinklers',
        value: 'bsmSprinklers',
        label: 'HRBs misting & sprinkler systems',
      },
      {
        id: 'bsmFireMitigation',
        value: 'bsmFireMitigation',
        label: 'HRBs other items to mitigate fire',
      },
    ],
  },
  {
    groupId: 'environmentalHealth',
    label: 'Environmental Health (Private Sector Housing Service)',
    options: [
      {
        id: 'infested',
        value: 'infested',
        label: 'Property verminous or infested',
      },
    ],
  },
  {
    groupId: 'fsa',
    label: 'Fire Safety Advisors',
    options: [
      {
        id: 'fsaSprinklers',
        value: 'fsaSprinklers',
        label: 'Misting & sprinkler systems',
      },
      {
        id: 'fsaFireMitigation',
        value: 'fsaFireMitigation',
        label: 'Other items to mitigate fire',
      },
    ],
  },
  {
    groupId: 'followOnFireSafetyActions',
    label: 'Follow-on Fire Safety actions',
    options: [
      {
        id: 'conductRPEEP',
        value: 'conductRPEEP',
        label: 'Conduct RPEEP',
      },
    ],
  },
  {
    groupId: 'neighbourhoods',
    label: 'Neighbourhoods & Estate Services',
    options: [
      {
        id: 'careline',
        value: 'careline',
        label: 'Careline referrals',
      },
      {
        id: 'hoardingSupport',
        value: 'hoardingSupport',
        label: 'Hoarding support',
      },
      {
        id: 'rubbishRemovals',
        value: 'rubbishRemovals',
        label: 'Rubbish removals',
      },
      {
        id: 'tenancyFiles',
        value: 'tenancyFiles',
        label: 'Tenancy files',
      },
      {
        id: 'lfbAccess',
        value: 'lfbAccess',
        label: 'LFB access issues',
      },
    ],
  },
  {
    groupId: 'repairs',
    label: 'Repairs',
    options: [
      {
        id: 'fireAlarms',
        value: 'fireAlarms',
        label: 'Fire alarms',
      },
      {
        id: 'fireDoors',
        value: 'fireDoors',
        label: 'Fire doors',
      },
      {
        id: 'fireStopping',
        value: 'fireStopping',
        label: 'Fire stopping',
      },
      {
        id: 'otherRepairs',
        value: 'otherRepairs',
        label: 'Other',
      },
    ],
  },
  {
    groupId: 'adaptations',
    label: 'Adaptations/Occupational Therapy',
    options: [
      {
        id: 'aidsAndAdaptations',
        value: 'aidsAndAdaptations',
        label: 'Aids & adaptations',
      },
    ],
  },
] as const satisfies SelectOptionList;

export const getDepartmentFromActionType = (
  actionType: string,
): RecommendationDepartment | undefined =>
  actionTypeOptions.find(({ options }) => options.some(({ value }) => value === actionType))
    ?.groupId;

export const getActionTypeLabel = (actionType: string) =>
  actionTypeOptions
    .map(({ options }) => options)
    .flat()
    .find(({ value }) => value === actionType)?.label || '';
